import(/* webpackMode: "eager", webpackExports: ["Card","CardBody","CardActions"] */ "/home/runner/work/squadre/squadre/node_modules/@olinfo/react-components/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Schedule"] */ "/home/runner/work/squadre/squadre/src/app/(home)/schedule.tsx");
